import React, {Component} from 'react'
import PropTypes from "prop-types"
import ColName from './ColName'
import ColNumberBatches from './ColNumberBatches'
import ColActions from './ColActions'
import ColDateCreated from './ColDateCreated'
import ColTypePartner from "./ColTypePartner"

class PartnerRow extends Component {
    render() {
        const {partners, partnerURL} = this.props

        return partners.map(item => {
            return <tr key={item._id}>
                <ColName item={item}/>
                <ColTypePartner type={item.type_partner}/>
                <ColDateCreated created={item.created_at}/>
                <ColNumberBatches item={item}/>
                <ColActions code={item.code} partnerURL={partnerURL}/>
            </tr>
        })
    }
}

PartnerRow.propTypes = {
    partners: PropTypes.array.isRequired,
    partnerURL: PropTypes.string,
}

export default PartnerRow